import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from "../api.js";

const SignupForm = ({ onSignupSuccess }) => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  // Keep both states to avoid breaking callers; `agree` is the source of truth
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [agree, setAgree] = useState(false);

  // Document versions to persist with the user record
  const TERMS_VERSION = '2025-09-10';
  const PRIVACY_VERSION = '2025-09-10';

  const navigate = useNavigate();

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage('');

    if (!agree) {
      setErrorMessage('You must agree to the Terms and Privacy Policy to create an account.');
      return;
    }

    const storedQuizAnswers = localStorage.getItem("quizAnswers");
    const storedQuizScores = localStorage.getItem("quizScores");

    const accountData = {
      username,
      email,
      password,
      phone_number: phoneNumber,
      quiz_answers: storedQuizAnswers ? JSON.parse(storedQuizAnswers) : {},
      quiz_scores: storedQuizScores ? JSON.parse(storedQuizScores) : {},
      // ✅ backend consent fields
      agree_terms: true,
      consent_sensitive: true,
      terms_version: TERMS_VERSION,
      privacy_version: PRIVACY_VERSION
    };

    try {
      const response = await api.post(`${API_BASE_URL}/create_account/`, accountData);
      if (response.status === 200) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user_id', response.data.user_id);
        if (typeof onSignupSuccess === 'function') {
          onSignupSuccess(response.data.token, response.data.user_id);
        }
        // Land them where they can start using the product right away
        navigate('/frameworks');
      } else {
        setErrorMessage('Signup failed. Please try again.');
      }
    } catch (error) {
      let errDetail = error?.response?.data?.detail;
      if (Array.isArray(errDetail)) {
        errDetail = errDetail.map((err) => err.msg || JSON.stringify(err)).join(" ");
      } else if (typeof errDetail === "object" && errDetail !== null) {
        errDetail = JSON.stringify(errDetail);
      }
      setErrorMessage(errDetail || 'Something went wrong. Please try again.');
    }
  };

  return (
    <div className="container">
      {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
      <form onSubmit={handleFormSubmit}>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
          autoComplete="username"
        />
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoComplete="email"
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoComplete="new-password"
        />
        <input
          type="text"
          placeholder="Phone Number"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          required
          autoComplete="tel"
        />

        {/* Consent checkbox (controlled). We sync both agree + agreeTerms to avoid surprises. */}
        <label
          className="signup-consent"
          style={{
            display: 'flex',
            gap: '10px',
            alignItems: 'flex-start',
            color: '#e8eef7' // readable on dark
          }}
        >
          <input
            type="checkbox"
            checked={agree}
            onChange={(e) => {
              setAgree(e.target.checked);
              setAgreeTerms(e.target.checked);
            }}
            style={{ marginTop: '4px' }}
          />
          <span>
            I agree to the{' '}
            <a href="/terms" target="_blank" rel="noreferrer" style={{ color: '#79c6ff' }}>
              Terms of Service
            </a>{' '}
            and{' '}
            <a href="/privacy" target="_blank" rel="noreferrer" style={{ color: '#79c6ff' }}>
              Privacy Policy
            </a>{' '}
            and consent to processing of sensitive personal data.
          </span>
        </label>

        <button type="submit" className="btn btn-success mt-2" disabled={!agree}>
          Sign Up
        </button>
      </form>
    </div>
  );
};

export default SignupForm;
